import { useState } from 'react';
import { Button } from '@/components/ui/button';

interface DecisionTraceProps {
  trace: Record<string, unknown> | null;
}

export const DecisionTrace = ({ trace }: DecisionTraceProps): JSX.Element => {
  const [open, setOpen] = useState(false);
  if (!trace) return <></>;

  return (
    <div className="rounded-lg border bg-card">
      <div className="flex items-center justify-between px-3 py-2">
        <div className="text-xs font-semibold text-muted-foreground">Decision trace</div>
        <Button variant="ghost" size="sm" onClick={() => setOpen((prev) => !prev)}>
          {open ? 'Hide' : 'Show'}
        </Button>
      </div>
      {open && (
        <pre
          className="max-h-60 overflow-auto border-t bg-muted/40 px-3 py-3 text-[11px] text-muted-foreground"
          data-content-origin="domain"
        >
          {JSON.stringify(trace, null, 2)}
        </pre>
      )}
    </div>
  );
};
